const tableFieldTypes = ['textbox','email', 'textarea', 'number', 'currency', 'date', 'time', 'datetime', 'options', 'upload', 'userselect', 'paymentform'];

export default tableFieldTypes